import script from "./PatientAllergies.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAllergies.vue?vue&type=script&setup=true&lang=js"

import "./PatientAllergies.vue?vue&type=style&index=0&id=028d1203&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028d1203"]])

export default __exports__